<b3-modal
  [open]="open"
  overlay
  size="md"
  (b3-close)="onModalDismiss()">
  <b3-modal-header
    [heading]="viewModel.heading"
    aria-level="2"
    [icon]="viewModel.icon"
    [icon-tone]="viewModel.iconTone"
    close-aria-label="Fechar">
  </b3-modal-header>

  <b3-modal-body>
    <p class="withdrawal-result-modal__text">{{ viewModel.bodyText }}</p>
    <p class="withdrawal-result-modal__control-number" *ngIf="viewModel.operationCode">
      Número de controle: <strong>{{ viewModel.operationCode }}</strong>
    </p>
  </b3-modal-body>

  <b3-modal-footer>
    <div class="withdrawal-result-modal__footer">
      <ng-container *ngIf="viewModel.mode === 'success'; else errorActions">
        <b3-button
          type="button"
          variant="outlined"
          tone="default"
          (b3-click)="onNewWithdrawal()">
          Nova retirada
        </b3-button>
        <b3-button
          type="button"
          variant="filled"
          tone="default"
          (b3-click)="onConsultOperation()">
          Consultar operação
        </b3-button>
      </ng-container>

      <ng-template #errorActions>
        <b3-button
          type="button"
          variant="outlined"
          tone="default"
          (b3-click)="onSupport()">
          Suporte B3
        </b3-button>
        <b3-button
          type="button"
          variant="filled"
          tone="default"
          (b3-click)="onRetry()">
          Tentar novamente
        </b3-button>
      </ng-template>
    </div>
  </b3-modal-footer>
</b3-modal>
